module.exports = __webpack_public_path__ + "img/48.56c74305.png";